module.exports = __webpack_public_path__ + "img/code.6ca21a89.png";